import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Gives information about the user's device.
 * Can be used to conditionally display UI elements
 */
export function useBreakpoints() {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const isTablet =
    useMediaQuery((theme) => theme.breakpoints.up("md")) && !isDesktop;
  const isMobile = !isDesktop && !isTablet;
  return { isDesktop, isTablet, isMobile };
}
